<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-flower-tulip"
      icon-small
      title="لیست درخواست وام ها"
      color="accent"
    >
      <v-row>
        <v-col
          cols="12"
          style="padding:0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="500"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>{{ row.item.memberModel.fullName }}</td>
                    <td>{{ row.item.memberModel.personalCode }}</td>
                    <td>{{ row.item.loanModel.title }}</td>
                    <td class="text-center">
                      {{ row.item.amount.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ `${row.item.requestDate_Persian.date}` }}
                    </td>
                    <td class="text-center">
                      {{ row.item.str_Status }}
                    </td>
                    <td class="text-center">
                      {{ row.item.status >= 3 ? `${row.item.year}/${row.item.month}` : 'تعیین نشده' }}
                    </td>
                    <td>
                      {{ (row.item.adminDescription || '-') }}
                    </td>
                    <td class="text-center">
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="secondary"
                        @click="edit(row.item)"
                      >
                        <v-icon dark>
                          mdi-square-edit-outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="pink"
                        @click="remove(row.item)"
                      >
                        <v-icon dark>
                          mdi-trash-can-outline
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">مشخصات درخواست وام</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <modify-request
                ref="modifyRequest"
                :data="selectedRequest"
                @callbck="callbck"
              />
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import { emptyId } from '@/util/emptyId'
  import ModifyLoanRequest from './ModifyLoanRequest.vue'

  export default {
    name: 'AdminLoanRequestsView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'modify-request': ModifyLoanRequest,
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        selectedRequest: {},
        dialog: false,
        search: '',
        headers: [
          {
            text: 'نام',
            align: 'start',
            sortable: true,
            value: 'memberModel.fullName',
          },
          {
            text: 'کد پرسنلی',
            align: 'start',
            sortable: true,
            value: 'memberModel.personalCode',
          },
          {
            text: 'وام',
            align: 'start',
            sortable: true,
            value: 'loanModel.title',
          }, {
            text: 'مبلغ',
            align: 'center',
            sortable: true,
            value: 'amount',
          }, {
            text: 'تاریخ ثبت درخواست',
            align: 'center',
            sortable: true,
            value: 'requestDate_Persian',
          }, {
            text: 'وضعیت',
            align: 'center',
            sortable: true,
            value: 'str_Status',
          }, {
            text: 'اولویت',
            align: 'start',
            sortable: true,
            value: 'month',
          }, {
            text: 'نظر هیئت مدیره',
            align: 'start',
            sortable: true,
            value: 'adminDescription',
          }, {
            text: 'عملیات ها',
            align: 'center',
            sortable: false,
            width: 150,
          },
        ],
        items: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        api.get('admin/userLoanRequest/list', null)
          .then(
            response => {
              this.items = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      add () {
        this.dialog = true
        this.selectedRequest = { id: emptyId }
        this.$nextTick(() => {
          this.$refs.modifyRequest.prepareData()
        })
      },
      edit (item) {
        this.dialog = true
        this.selectedRequest = item
        this.$nextTick(() => {
          this.$refs.modifyRequest.prepareData()
        })
      },
      callbck (result) {
        this.dialog = false
        if (result) { this.loadData() }
      },
      async remove (item) {
        if (!item) { return }

        if (await this.$refs.confirm.open(
          'توجه',
          'آیا از حذف این آیتم مطمئن هستید؟',
        )) {
          api.post('admin/userLoanRequest/delete/' + item.id)
            .then(
              response => {
                toast.success('اطلاعات با موفقیت حذف شد.')
                this.loadData()
              })
            .catch(err => {
              toast.error(err.message)
            })
        }
      },
    },
  }
</script>
<style>
</style>
